import React from "react";
import { __t } from "../../utils/translate";

type BurgerMenuProps = {
    className?: string;
    isMenuOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
};

export const BurgerMenuClose: React.FC<BurgerMenuProps> = ({
    className,
    setIsOpen,
}) => {
    return (
        <button
            className={`${className} relative h-[30px] w-[30px] focus:outline-none`}
            onClick={() => setIsOpen(false)}
        >
            <span className="sr-only">{__t("Close main menu")}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M24.9431 8.94265C25.4638 8.42195 25.4638 7.57773 24.9431 7.05703C24.4224 6.53633 23.5782 6.53633 23.0575 7.05703L16.0003 14.1142L8.94313 7.05703C8.42244 6.53633 7.57822 6.53633 7.05752 7.05703C6.53682 7.57773 6.53682 8.42195 7.05752 8.94265L14.1147 15.9998L7.05752 23.057C6.53682 23.5777 6.53682 24.4219 7.05752 24.9426C7.57822 25.4633 8.42244 25.4633 8.94313 24.9426L16.0003 17.8855L23.0575 24.9426C23.5782 25.4633 24.4224 25.4633 24.9431 24.9426C25.4638 24.4219 25.4638 23.5777 24.9431 23.057L17.8859 15.9998L24.9431 8.94265Z" fill="#B6C5D1" />
            </svg>
        </button>
    );
};

export const BurgerMenuOpen: React.FC<BurgerMenuProps> = ({
    className,
    setIsOpen,
}) => {
    return (
        <button
            className={`${className} relative h-[26px] w-[30px] focus:outline-none`}
            onClick={() => setIsOpen(true)}
        >
            <span className="sr-only">{__t("Open main menu")}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M1 5H0V7H1H27H28V5H27H1ZM7 11H6V13H7H27H28V11H27H7ZM1 17H0V19H1H27H28V17H27H1ZM6 22H7H27H28V24H27H7H6V22Z" fill="#253A4C" />
            </svg>
        </button>
    );
};


export const BurgerMenuToggle: React.FC<BurgerMenuProps> = ({ className, setIsOpen, isMenuOpen }) => {
    const handleClick = () => {
        setIsOpen(!isMenuOpen);
    };

    return (
        <button
            className={`${className} relative h-[30px] w-[30px] focus:outline-none burger-menu-toggle ${isMenuOpen ? "open" : ""}`}
            onClick={handleClick}
            aria-label={isMenuOpen ? __t("Close main menu") : __t("Open main menu")}
        >
            <div className="burger-line top max-w-[18px]"></div>
            <div className="burger-line middle"></div>
            <div className="burger-line bottom max-w-[18px]"></div>
        </button>
    );
};
